const listeners = new Set();

const CREDIT_REFUSAL_CODES = new Set([
  "INSUFFICIENT_CREDITS",
  "TRIAL_EXPIRED",
  "SUBSCRIPTION_REQUIRED",
]);

const emit = (event) => {
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
    }
  });
};

export const subscribeToCreditState = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const publishCreditResponse = (response) => {
  const method = response?.config?.method?.toLowerCase();
  const responseData = response?.data;
  const billingState = responseData?.billing_summary?.state;
  const explicitChargeReported = [
    responseData?.charged_units,
    responseData?.total_charged,
  ].some((charged) => Number.isFinite(charged) && charged >= 0);
  const billingSettled = billingState === "charged"
    || billingState === "refunded"
    || explicitChargeReported;
  if ((!method || ["get", "head", "options"].includes(method)) && !billingSettled) return;

  emit({
    type: "metered-operation-completed",
    clearRefusal: billingSettled,
  });
};

export const publishCreditRefusal = (response) => {
  if (response?.status !== 402 && response?.status !== 403) return;

  const method = response?.config?.method?.toLowerCase();
  const url = response?.config?.url;
  const path = typeof url === "string"
    ? url.replace(/^https?:\/\/[^/]+/i, "").split("?")[0].replace(/\/+$/, "")
    : null;
  if (method === "get" && path === "/credits/balance") return;

  const detail = response?.data?.detail;
  if (!detail || !CREDIT_REFUSAL_CODES.has(detail.error_code)) return;

  emit({ type: "metered-operation-refused", refusalDetail: detail });
};
